import React, { useState } from "react";
import Dialog from "@mui/material/Dialog";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import Typography from "@mui/material/Typography";
import DialogTitle from "@mui/material/DialogTitle";
import { useParams } from "react-router";
import useMutation from "../../../hooks/useMutation";
import useNotification from "../../../hooks/notification";
import useAuth from "../../../hooks/useAuth";
import { CREATE_SHARED_CLIENT_PROJECT_MUTATION } from "../../../constants/graphql/mutations";
import Step0 from "./Step0";
import Step1 from "./Step1";

export default function AddProjectSharingModal({ onClose }) {
  const [step, setStep] = useState(0);
  const [loading, setLoading] = useState(false);
  const { projectId } = useParams();
  const { user } = useAuth();
  const { settings } = user.company;
  const [shareClientProject] = useMutation(CREATE_SHARED_CLIENT_PROJECT_MUTATION);
  const { notifySuccess, notifyError } = useNotification();

  const handleNext = () => {
    setStep(prev => prev + 1);
  };

  const handleBack = () => {
    setStep(prev => prev - 1);
  };

  const handleSubmit = ({ clientId }) => {
    setLoading(true);

    shareClientProject({
      variables: {
        clientId,
        projectId,
      },
      onSuccess: () => {
        setLoading(false);
        onClose();
        notifySuccess(`${settings.filter_field1} has been successfully shared`);
      },
      onFailure: errors => {
        setLoading(false);
        notifyError(errors);
        console.error(`Failed to share ${settings.filter_field1}:`, errors);
      },
    });
  };

  return (
    <Dialog
      open
      maxWidth="sm"
      fullWidth
      PaperProps={{
        sx: {
          borderRadius: 2,
          maxWidth: 600,
        },
      }}
      onClose={onClose}
    >
      <DialogTitle sx={{ p: 3 }}>
        <Typography
          align="center"
          color="textSecondary"
          sx={{ px: 2, fontWeight: 500, fontSize: 22 }}
        >
          {`${settings.filter_field1} Sharing`}
        </Typography>
        <IconButton
          onClick={onClose}
          size="small"
          sx={{ position: "absolute", right: 16, top: 16 }}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      {step === 0 && <Step0 onNext={handleNext} />}
      {step === 1 && <Step1 loading={loading} onBack={handleBack} onSubmit={handleSubmit} />}
    </Dialog>
  );
}
